import TimeAgo from 'react-timeago'
import { StyledLink } from 'baseui/link'
import {
    ParagraphXSmall,
} from 'baseui/typography';
import { useTimeAgoFormatter } from '../../hooks/useTimeAgoFormatter';
import { useIntl, FormattedMessage } from 'react-intl';
import { ColoredAvatar } from '../../components/ColoredAvatar';
import { useGetUserQuery } from '../../services/resourceGroups/userApi';
import { Block } from 'baseui/block';
import { useStyletron } from 'baseui';
import { IoCalendarOutline } from 'react-icons/io5';

export interface AckUserInfoProps {
    userId: string | undefined;
    userName: string;
    time: Date | null;
}

export const AckUserInfo = ({ userId, time, userName }: AckUserInfoProps) => {
    const { formatter } = useTimeAgoFormatter();
    const [css, theme] = useStyletron();
    const { data: user } = useGetUserQuery(userId ?? '', { skip: !userId || userId === '00000000-0000-0000-0000-000000000000' });

    const userNameDisplay = user ? user.name : userName;

    return (
        <Block display='flex' flexDirection='column'>
            <Block display='flex' flexDirection='row' alignItems='baseline' gridGap={theme.sizing.scale200}>
                <ColoredAvatar username={userNameDisplay} size='scale800' overrides={{
                    Initials: {
                        style: ({ $theme }) => ({
                            fontSize: $theme.typography.ParagraphXSmall.fontSize
                        })
                    }
                }}></ColoredAvatar>
                <ActivityDescr />
            </Block>
            <ParagraphXSmall margin={0} >
                <Block display='flex' flexDirection='row' alignItems='center' gridGap={theme.sizing.scale200}>
                    <IoCalendarOutline></IoCalendarOutline><TimeAgo date={time || new Date()} formatter={formatter}></TimeAgo>
                </Block>
            </ParagraphXSmall>
        </Block>
    )
}

const ActivityDescr = () => {
    return (<ParagraphXSmall margin={0}><FormattedMessage id='alarms.hasAcknowledged' defaultMessage='has acknowledged'></FormattedMessage></ParagraphXSmall>)
}


